import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { AirwallexTransfer } from './airwallex-transfer';

export class CreateAirwallexTransferDto extends Omit(
    AirwallexTransfer,
    [...BaseEntityFieldsArray, 'transferId', 'status', 'accountId', 'deduplicationId', 'airwallexBeneficiaryId', 'requestId'],
    [],
) {}
